var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12609_42481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.623 0 24 5.37703 24 12C24 18.623 18.623 24 12 24C5.37703 24 0 18.623 0 12C0 5.37703 5.37703 0 12 0ZM8.24827 18.744V9.37266H5.13277V18.744H8.24827ZM19.4805 18.744V13.3699C19.4805 10.4914 17.9436 9.1523 15.8941 9.1523C14.2415 9.1523 13.5013 10.0612 13.0868 10.6995V9.37266H9.97209C10.0134 10.2519 9.97209 18.744 9.97209 18.744H13.0868V13.5104C13.0868 13.2302 13.1069 12.9502 13.1895 12.75C13.4142 12.1905 13.9271 11.611 14.7877 11.611C15.9143 11.611 16.3656 12.4707 16.3656 13.7299V18.744H19.4805ZM6.71156 4.85391C5.64562 4.85391 4.9492 5.55469 4.9492 6.4732C4.9492 7.37236 5.62444 8.09245 6.67031 8.09245H6.69042C7.77675 8.09245 8.45292 7.37236 8.45292 6.4732C8.43277 5.55469 7.7768 4.85391 6.71156 4.85391Z",
    fill: "#2D2D2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12609_42481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.0c6ae7606ebfd483fc421f50be68e330.svg";
export { ForwardRef as ReactComponent };